import { TranslationKeys } from '@clientWebServices/translator.service';

export const MESSAGE_KEYS: Partial<Record<string, TranslationKeys>> = {
  success: 'success',
  error: 'error',
  loading: 'loading',
  noResults: 'no_results',
};
